import { render, staticRenderFns } from "./SkinColorTemplate.vue?vue&type=template&id=51a44d9e&scoped=true"
import script from "./SkinColorTemplate.vue?vue&type=script&lang=js"
export * from "./SkinColorTemplate.vue?vue&type=script&lang=js"
import style0 from "./SkinColorTemplate.vue?vue&type=style&index=0&id=51a44d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a44d9e",
  null
  
)

export default component.exports